import { render, staticRenderFns } from "./yue-du-xiao-shou.vue?vue&type=template&id=dc514146&scoped=true"
import script from "./yue-du-xiao-shou.vue?vue&type=script&lang=js"
export * from "./yue-du-xiao-shou.vue?vue&type=script&lang=js"
import style0 from "./yue-du-xiao-shou.vue?vue&type=style&index=0&id=dc514146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_00c06ca9196352b30e67b45b8b60d79f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc514146",
  null
  
)

export default component.exports